module.exports = __webpack_public_path__ + "img/octaveHead.1d0bbe50.jpg";